import { Injectable } from '@angular/core';
import {Http, Response, RequestOptions, Headers} from '@angular/http';
import {Observable} from 'rxjs/Observable';
import 'rxjs/add/operator/map';
import 'rxjs/add/operator/catch';
import 'rxjs/add/observable/throw';

import { GlobalDataService } from '../../../services/global-data.service';

@Injectable()
export class CashboxService {

  authtoken: string = localStorage.getItem('token');
  headers = new Headers();
  constructor(private http: Http, private global: GlobalDataService) {
            
             this.headers.append("Authorization", 'Bearer' + this.authtoken);
             this.headers.append('X-Requested-With', 'XMLHttpRequest')
             this.headers.append('Content-Type', 'application/json;')
   }


   getCashBoxListService() {
        return this.http.get(this.global.httpUrl+"cashboxes",{headers: this.headers})
                    .map((response: Response) =>response.json())
    }

   getCashBoxListByIdService(id: any) {
        return this.http.get(this.global.httpUrl+"cashboxes/transactions?cashbox_id="+id,{headers: this.headers})
                        .map((response: Response) =>response.json())
    }

   createCashBoxDayService(data: any){
        return this.http.post(this.global.httpUrl+'cashboxes', data, { headers: this.headers })
                        .map((resp:Response)=>resp.json())
                        .catch((error:any) =>{return Observable.throw(error);}); 
    }

    closeCashBoxService(data: any){
        return this.http.post(this.global.httpUrl+'cashboxes/'+data['cashboxes_id']+'/close', data, { headers: this.headers })
                        .map((resp:Response)=>resp.json())
                        .catch((error:any) =>{return Observable.throw(error);}); 
    }
}



// WEBPACK FOOTER //
// C:/Users/User/Documents/Projects/Ekopen/angular2-store-test/src/app/dashboard/pages/cashboxes/cashbox.service.ts